import type React from 'react'
import type { BaseModalProps } from '../Modal/BaseModal.js'
import { BaseModal } from '../Modal/BaseModal.js'
import { BlastVersionsTab } from './BlastVersionsTab.tsx'

export const PipelineSettingsWidget: React.FC<BaseModalProps> = ({ isOpen, onClose }) => {
  return (
    <>
      <BaseModal isOpen={isOpen} onClose={onClose}>
        <div className="modal-box w-1/2 max-w-full h-auto max-h-[90vh] overflow-auto">
          <div className="p-6">
            <h3 className="text-xl font-bold">Pipeline Information</h3>

            <div className="flex flex-row p-4">
              <div className="w-1/2">
                <ListBlock
                  title={'Preprocessing Steps'}
                  lines={[
                    'Paired-end read merging: performed using USEARCH (-fastq_mergepairs) with max 99 differences, min 75% identity, and truncation disabled.',
                    'Adapter trimming: conducted using CUTADAPT, discarding reads without expected adapter sequences.',
                    'Quality filtering: applied via VSEARCH (--fastq_filter), allowing a maximum of 1 expected error per sequence and a read length of 300-315 bases.',
                    'Dereplication: performed within each sample using VSEARCH (--derep_fulllength), retaining one unique copy per sequence.'
                  ]}
                />
                <ListBlock
                  title={'Clustering & Chimera Filtering'}
                  lines={[
                    'OTU Clustering: sequences pre-clustered at 98% identity before chimera filtering using VSEARCH (--cluster_size).',
                    'Chimera detection: removed using VSEARCH (--uchime_denovo).',
                    'OTU Sorting: representative OTU sequences sorted by size.'
                  ]}
                />
              </div>
              <div className="w-1/2">
                <ListBlock
                  title={'Final Clustering & Filtering'}
                  lines={[
                    'Final OTU clustering: using SWARM 3.1.0 (with -d 12) for CO1, other amplicons are clustered using vsearch',
                    'CO1 Jobs exceeding 1.500.000 sequences are also clustered using vsearch',
                    'OTU Table Generation: constructed using VSEARCH (--usearch_global).',
                    'Contamination control: OTUs found in negative controls were filtered out if their abundance in any sample was lower than their highest occurrence in negative controls.'
                  ]}
                />
                <ListBlock
                  title={'Reference Databases, BLAST, and classification'}
                  lines={[
                    'Reference dataset: NCBI/Genbank nucleotide database (all amplicons) + filtered COI or ITS BOLD database; Silva database for 16S.',
                    'RDP classifier: used in addition to the two BLAST searches; trained on Unite database for ITS and on the Midori RDP dataset for all other amplicons',
                    'Processing Methods: aligned with Uhler et al. (2022).',
                    'Databases are refreshed regularly and filtered to applicable amplicons.'
                  ]}
                />
              </div>
            </div>

            <BlastVersionsTab />

            <div className="modal-action">
              <button className="btn btn-primary" onClick={() => onClose()}>
                Close
              </button>
            </div>
          </div>
        </div>
      </BaseModal>
    </>
  )
}

export const ListBlock: React.FC<{ title: string; lines: string[] }> = ({ title, lines }) => {
  return (
    <div className="p-4">
      <div>
        <h3 className="text-lg font-bold">{title}</h3>
      </div>
      <div>
        <ul className={'list list-disc list-inside'}>
          {lines.map((x, index) => (
            <li className={'list-row'} key={index}>
              {x}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
